import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const paymentTerms: LegalDoc = {
  slug: "payment-terms",
  title: "Điều khoản thanh toán",
  metaTitle: "Điều khoản thanh toán",
  metaDescription:
    "Gói thuê bao, lượt săn ứng viên, phương thức thanh toán, chính sách không hoàn tiền và hoá đơn trên Chốt Ca.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro: `Điều khoản này áp dụng cho mọi khoản phí mà **Nhà tuyển dụng** trả cho **${C.legalName}** khi sử dụng nền tảng Chốt Ca.\n\n**Người tìm việc không phải trả bất kỳ khoản phí nào.** Toàn bộ tính năng dành cho Người tìm việc, gồm tạo hồ sơ, xem tin, ứng tuyển và nhận lời mời phỏng vấn, là miễn phí và không có gói trả phí nào. Nếu có ai yêu cầu bạn nộp tiền để dùng Chốt Ca hoặc để được nhận việc qua Chốt Ca, đó là lừa đảo — vui lòng báo ngay tới ${C.abuseEmail}.`,
  sections: [
    {
      title: "1. Những gì có phí và những gì miễn phí",
      sections: [
        {
          title: "1.1. Luôn miễn phí",
          items: [
            "Toàn bộ tính năng dành cho Người tìm việc.",
            "Tạo tài khoản Nhà tuyển dụng và **đăng tin tuyển dụng**. Chốt Ca không thu phí đăng tin, không thu phí theo ca, không thu phí khi tuyển thành công.",
            "**Nhận và xem đơn ứng tuyển** của người chủ động ứng tuyển vào tin của bạn, gồm đầy đủ hồ sơ và thông tin liên hệ.",
            "**Mời phỏng vấn người đã chủ động ứng tuyển** vào tin của bạn. Việc này không trừ lượt nào, kể cả khi bạn đang dùng gói Miễn phí.",
            "Duyệt Kho ứng viên ở dạng che.",
          ],
        },
        {
          title: "1.2. Có phí",
          items: [
            "**Gói thuê bao 30 ngày**: nâng hạn mức số tin được mở cùng lúc, số lượt săn ứng viên và số lượt đẩy tin trong mỗi kỳ.",
            "**Lượt săn ứng viên**: bị trừ khi bạn chủ động gửi lời mời phỏng vấn tới một người trong Kho ứng viên, tức người bạn tìm thấy chứ không phải người đã ứng tuyển vào tin của bạn.",
            "**Lượt đẩy tin (boost)**: đưa một tin lên nhóm ưu tiên của bảng tin trong **3 ngày**.",
            "**Gói mua thêm ngoài thuê bao**: lượt săn ứng viên và lượt đẩy tin mua lẻ.",
          ],
        },
      ],
    },
    {
      title: "2. Bảng giá và hạn mức",
      body: "Bảng giá, hạn mức của từng gói và số lượt trong từng gói mua thêm **luôn được hiển thị đầy đủ trên màn hình thanh toán trước khi bạn xác nhận**. Bảng giá trong ứng dụng là bảng giá có hiệu lực. Chúng tôi cam kết:",
      items: [
        "Giá niêm yết là giá cuối cùng, **đã bao gồm thuế giá trị gia tăng** theo quy định pháp luật Việt Nam.",
        "**Không phát sinh phụ phí** ngoài giá đã hiển thị tại thời điểm bạn xác nhận giao dịch.",
        "Khi thay đổi giá, giá mới chỉ áp dụng cho giao dịch phát sinh sau ngày hiệu lực. Chúng tôi **không truy thu** và **không thay đổi giá của kỳ bạn đã thanh toán**.",
        "Chốt Ca có thể điều chỉnh hạn mức của các gói. Việc điều chỉnh làm giảm quyền lợi chỉ áp dụng từ kỳ mua tiếp theo, không áp dụng cho kỳ đang chạy của bạn.",
      ],
    },
    {
      title: "3. Cách gói thuê bao vận hành",
      items: [
        "**Thời hạn 30 ngày** kể từ khi thanh toán được ghi nhận.",
        "**Không tự động gia hạn và không tự động trừ tiền.** Bạn không cần thao tác huỷ. Hết hạn, tài khoản tự chuyển về gói Miễn phí.",
        "Khi tụt về gói Miễn phí, các tin đang mở vượt hạn mức của gói Miễn phí sẽ không còn được hiển thị cho tới khi bạn đóng bớt tin hoặc mua gói mới. **Dữ liệu tin và đơn ứng tuyển của bạn không bị xoá.**",
        "**Mua tiếp đúng gói đang dùng khi còn hạn**: số ngày được cộng dồn vào phần thời hạn còn lại.",
        "**Đổi sang gói khác**: một kỳ mới bắt đầu ngay và bộ đếm sử dụng được đặt lại.",
        "**Hạn mức lượt săn và lượt đẩy tin của gói được đặt lại mỗi kỳ và không cộng dồn** sang kỳ sau.",
        "**Lượt mua thêm ngoài gói không hết hạn** và được cộng dồn qua các kỳ.",
        "**Thứ tự trừ**: hệ thống luôn dùng hết hạn mức của gói trước, sau đó mới dùng tới lượt bạn đã mua thêm.",
      ],
    },
    {
      title: "4. Phương thức thanh toán",
      items: [
        "Chốt Ca chỉ chấp nhận **chuyển khoản ngân hàng qua mã QR**, xử lý qua đối tác **Sepay**.",
        "Chốt Ca **không** chấp nhận thẻ tín dụng hoặc thẻ ghi nợ quốc tế, **không** dùng VNPay, MoMo hay ZaloPay, và **không** có ví điện tử hay tính năng nạp tiền vào tài khoản.",
        "Mỗi đơn hàng có **nội dung chuyển khoản riêng** và **thời hạn thanh toán**. Chuyển khoản sai nội dung hoặc sau thời hạn có thể khiến đơn không được ghi nhận tự động và cần liên hệ hỗ trợ để đối soát thủ công.",
        "Chốt Ca **không lưu trữ thông tin tài khoản ngân hàng hay thông tin thẻ** của bạn.",
      ],
    },
    {
      title: "5. Xác nhận giao dịch",
      items: [
        "Đơn hàng được tạo ở trạng thái chờ thanh toán. Giao dịch hoàn tất khi Chốt Ca nhận được xác nhận từ Sepay, thường trong vòng vài phút.",
        "Ngay khi giao dịch hoàn tất, quyền lợi tương ứng được cộng vào tài khoản doanh nghiệp của bạn và bạn nhận được thông báo.",
        `Nếu đã bị trừ tiền nhưng sau **30 phút** quyền lợi chưa xuất hiện, gửi mã đơn hàng và ảnh chụp biên lai chuyển khoản tới **${C.billingEmail}**. Chúng tôi đối soát và xử lý trong **03 ngày làm việc**.`,
        "Toàn bộ lịch sử đơn hàng và giao dịch của bạn được lưu trong khu vực quản trị của tài khoản Nhà tuyển dụng để bạn tra cứu, tải về và in bất cứ lúc nào, theo Điều 39 Luật Bảo vệ quyền lợi người tiêu dùng 2023.",
      ],
    },
    {
      title: "6. Chính sách hoàn tiền",
      sections: [
        {
          title: "6.1. Nguyên tắc: không hoàn tiền",
          body: "Các khoản đã thanh toán cho gói thuê bao, lượt săn ứng viên và lượt đẩy tin **không được hoàn lại bằng tiền**. Cụ thể, chúng tôi không hoàn tiền khi bạn đổi ý sau khi thanh toán, khi bạn không dùng hết hạn mức trong kỳ, khi ứng viên từ chối hoặc không phù hợp với cơ sở của bạn, khi bạn tuyển được người qua kênh khác, hoặc khi tài khoản bị khoá do bạn vi phạm điều khoản.",
        },
        {
          title: "6.2. Cơ chế bảo vệ thay cho hoàn tiền",
          body: "Thay vì hoàn tiền, Chốt Ca bảo vệ bạn bằng cách **hoàn lại lượt săn ứng viên** khi lời mời không đi tới đâu vì lý do không thuộc về bạn:",
          items: [
            "Người tìm việc **từ chối** lời mời phỏng vấn của bạn: lượt săn được hoàn lại tự động.",
            "Người tìm việc **không trả lời trong 24 giờ** và lời mời hết hạn: lượt săn được hoàn lại tự động.",
            "Người tìm việc **đổi ý trong cửa sổ 30 phút** sau khi nhận lời mời: lượt săn được hoàn lại tự động.",
            "Lời mời đã chốt lịch phỏng vấn thì lượt săn được tính là đã sử dụng. Trường hợp huỷ sau khi đã chốt lịch, bạn gửi yêu cầu và quản trị viên Chốt Ca xem xét từng trường hợp cụ thể.",
          ],
        },
        {
          title: "6.3. Trường hợp lỗi thuộc về Chốt Ca",
          body: "Chính sách không hoàn tiền **không áp dụng** khi lỗi thuộc về chúng tôi. Trong các trường hợp sau, chúng tôi khắc phục bằng cách cấp bù quyền lợi tương ứng, gia hạn thời hạn gói, hoặc hoàn tiền về tài khoản ngân hàng nguồn nếu bạn yêu cầu:",
          items: [
            "Hệ thống tính phí trùng cho cùng một giao dịch.",
            "Bạn đã thanh toán nhưng không nhận được quyền lợi và lỗi không nằm ở phía bạn.",
            "Sự cố kỹ thuật kéo dài từ phía Chốt Ca khiến bạn không sử dụng được dịch vụ đã trả tiền trong một phần đáng kể của kỳ.",
            "Chốt Ca chấm dứt cung cấp dịch vụ hoặc gỡ bỏ tính năng bạn đã trả tiền trước khi kỳ của bạn kết thúc.",
          ],
        },
        {
          title: "6.4. Quy trình",
          body: `Gửi yêu cầu tới **${C.billingEmail}** kèm mã đơn hàng, mô tả sự việc và ảnh chụp màn hình nếu có. Chúng tôi phản hồi trong **05 ngày làm việc**. Trường hợp được chấp thuận hoàn tiền, tiền được chuyển về tài khoản ngân hàng nguồn trong **07 tới 14 ngày làm việc** tuỳ ngân hàng. Nếu từ chối, chúng tôi nêu rõ lý do bằng văn bản.`,
        },
      ],
    },
    {
      title: "7. Khiếu nại giao dịch",
      items: [
        "Gửi khiếu nại trong **60 ngày** kể từ ngày giao dịch, qua khu vực hỗ trợ trong tài khoản hoặc email kế toán.",
        "Cung cấp mã đơn hàng, biên lai chuyển khoản, ảnh chụp màn hình và mô tả chi tiết sự việc.",
        "Chúng tôi phối hợp với Sepay và ngân hàng để xác minh. Quá trình đối soát thông thường mất tới **15 ngày làm việc**, các trường hợp phức tạp cần ngân hàng tra soát có thể lâu hơn và chúng tôi cập nhật tiến độ cho bạn.",
      ],
    },
    {
      title: "8. Hoá đơn điện tử",
      body: `Chốt Ca xuất hoá đơn giá trị gia tăng dạng điện tử theo **Nghị định 123/2020/NĐ-CP**. Để nhận hoá đơn, vui lòng cung cấp tên doanh nghiệp, mã số thuế và địa chỉ trong vòng **07 ngày** kể từ ngày thanh toán, qua ${C.billingEmail} hoặc phần thông tin xuất hoá đơn trong tài khoản. Sau thời hạn này, hoá đơn được xuất theo thông tin đang có trên tài khoản của bạn. Hoá đơn được gửi tới email đăng ký và lưu trong lịch sử giao dịch của tài khoản.`,
    },
    {
      title: "9. Tiền lương không đi qua Chốt Ca",
      body: "Lương, thưởng, phụ cấp, tiền đặt cọc và mọi khoản thanh toán giữa Nhà tuyển dụng và người lao động là quan hệ trực tiếp giữa hai bên và **không đi qua Nền tảng Chốt Ca** dưới bất kỳ hình thức nào. Chốt Ca không giữ tiền, không thu hộ, không chi hộ, không ký quỹ và không bảo lãnh cho bất kỳ nghĩa vụ thanh toán nào. Tranh chấp về tiền lương được giải quyết giữa hai bên theo **Bộ luật Lao động 2019**.",
    },
    {
      title: "10. Quyền của bạn theo pháp luật bảo vệ người tiêu dùng",
      body: "Theo **Luật Bảo vệ quyền lợi người tiêu dùng số 19/2023/QH15**, bạn có quyền:",
      items: [
        "Được cung cấp thông tin chính xác, đầy đủ về dịch vụ, giá và điều kiện giao dịch trước khi thanh toán.",
        "Được lựa chọn, từ chối hoặc dừng sử dụng dịch vụ theo các điều kiện đã công bố.",
        "Được truy cập, tra cứu, tải về và in hoá đơn, chứng từ liên quan tới giao dịch của mình.",
        "Được yêu cầu bồi thường thiệt hại do dịch vụ không đúng như đã công bố gây ra.",
        "Được khiếu nại, tố cáo và khởi kiện theo quy định của pháp luật.",
      ],
    },
  ],
  contact: {
    title: "11. Liên hệ kế toán và hoá đơn",
    prefix:
      "Mọi yêu cầu về thanh toán, hoá đơn, đối soát giao dịch xin gửi về ",
    email: C.billingEmail,
  },
};
